<template>
  <div class="all-check-uncheck" style="display: flex; gap: 5px;">
    <check-box
      :selected="true"
      @change="click2()"
    ></check-box>
    <check-box
      :selected="false"
      @change="click()"
    ></check-box>
  </div>
</template>

<script>
import CheckBox from "./CheckBox.vue";

export default {
  components: { CheckBox },
  props: ["items", "selectedProperty", "disabledProperty"],
  methods: {
    click() {
      this.uncheckClick();
    },
    click2() {
      this.checkClick();   
    },
    checkClick() {
      this.items.forEach((element) => {
        if(this.disabledProperty)
        {
          if(element[this.disabledProperty] != true) {
            element[this.selectedProperty] = true;
          }
        }
        else
        {
          element[this.selectedProperty] = true;
        }
      });
    },
    uncheckClick() {
      this.items.forEach((element) => {
        if(this.disabledProperty)
        {
          if(element[this.disabledProperty] != true) {
            element[this.selectedProperty] = false;
          }
        }
        else
        {
          element[this.selectedProperty] = false;
        }
      });
    },
  },
  computed: {
    allChecked() {
      return this.items.every((x) => x[this.selectedProperty] === true);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Fejléc check / uncheck gombok — alapból 31px széles, 34px magas, nem lekerekített */
.all-check-uncheck ::v-deep .v-btn.custom-check-box {
  width: 34px !important;
  height: 31px !important;
  min-width: 31px !important;
  border-radius: 0 !important;
}
</style>
